<template>
  <p class="panel-title">{{ $t('app.campaign.newPage.slidingPanel.campaignConfig.title') }}</p>
  <div tabindex="0" @keydown.enter="save" v-if="currentCampaign" class="basic-info-panel-content">
    <ChooseSpace v-model="currentCampaign"></ChooseSpace>
    <EnterCampaignName v-model="currentCampaign"></EnterCampaignName>
    <EnterJob v-model="currentCampaign"></EnterJob>
  </div>
  <div class="edit-buttons">
    <Button class="secondary" :label="$t('app.campaign.newPage.slidingPanel.buttons.cancel')" @click="emit('close')"></Button>
    <Button class="green" :label="$t('app.campaign.newPage.slidingPanel.buttons.save')" @click="save"></Button>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.panel-title {
  color: var(--secondary-color);
  font-family: $bioSans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 32px;
}

.basic-info-panel-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edit-buttons {
  margin-top: 32px;
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: end;
}

</style>

<script setup lang="ts">
import EnterCampaignName from '../steps/EnterCampaignName.vue';
import ChooseSpace from '../steps/ChooseSpace.vue';
import EnterJob from '../steps/EnterJob.vue';
import Button from '@/components/global/Button.vue';

const props = defineProps<{
  campaign: CampaignCreation,
}>();

const currentCampaign: Ref<CampaignCreation> = ref(undefined);

const emit = defineEmits<{
  (e: 'save', value: CampaignCreation): void,
  (e: 'valid', value: boolean): void,
  (e: 'close'): void,
}>();

function save() {
  emit('save', structuredClone(toRaw(currentCampaign.value)));
  emit('close');
}

onMounted(() => {
  currentCampaign.value = structuredClone(toRaw(props.campaign));
});
</script>